export const SealMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="3" y="3" width="58" height="58" rx="9" fill="#B85B38" />
    <rect x="9" y="9" width="46" height="46" rx="5" fill="none" stroke="#FDFBF7" strokeWidth="2" opacity="0.85" />
    <path d="M19 22 C 28 19, 38 19, 45 21 C 36 30, 28 37, 19 44 C 28 42, 37 42, 46 44" fill="none" stroke="#FDFBF7" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="47" cy="15.5" r="2.6" fill="#E7C27D" />
  </svg>
);

export const Logo = ({ name, onClick }) => (
  <button onClick={onClick} data-testid="nav-logo" className="group flex items-center gap-3">
    <span className="transition-transform duration-500 group-hover:-rotate-6"><SealMark /></span>
    <span className="flex flex-col items-start leading-none">
      <span className="font-serif text-xl tracking-tight text-ink">Ruiting Zou</span>
      <span className="mt-1 text-[11px] uppercase tracking-[0.28em] text-muted-ink">{name}</span>
    </span>
  </button>
);
